import React from "react";
import getClass from "../utils/classNames";
export function Container(e) {
  var t = e.fluid,
      a = e.children,
      r = e.tagName,
      n = e.className,
      i = [n, getClass(t ? "container-fluid" : "container")].filter(function (e) {
    return e;
  }).join(" ");
  return React.createElement(r || "div", {
    className: i,
    children: a
  });
}
export default Container;